import { render, staticRenderFns } from "./management-organization-members-view.vue?vue&type=template&id=040a94a5&scoped=true&"
import script from "./management-organization-members-view.vue?vue&type=script&lang=js&"
export * from "./management-organization-members-view.vue?vue&type=script&lang=js&"
import style0 from "./management-organization-members-view.vue?vue&type=style&index=0&id=040a94a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a94a5",
  null
  
)

export default component.exports